// import { transformUrlProxy, SLD } from '@patsnap-utils/biz';

export const EUREKA_SERVICE_URI = import.meta.env.VITE_EUREKA_SERVICE_URI;
export const ANALYTICS_URI = import.meta.env.VITE_ANALYTICS_URI;
export const ACCOUNT_SERVICE_URI = import.meta.env.VITE_ACCOUNT_SERVICE_URI;
export const CORE_SEARCH_SERVICE_URI = import.meta.env.VITE_CORE_SEARCH_SERVICE_URI;

export const EUREKA_URI = import.meta.env.VITE_EUREKA_URI;
export const DRAFTING_FE_BASE_URL = `${EUREKA_URI}/ip/drafting`;

// 根据配置选择后端地址
// VITE_USE_LOCAL_BACKEND=1 使用本地后端 (VITE_LOCAL_BACKEND_URL)
// VITE_USE_LOCAL_BACKEND=0 使用远程后端 (EUREKA_SERVICE_URI/drafting)
const USE_LOCAL_BACKEND = import.meta.env.VITE_USE_LOCAL_BACKEND === '1';

export const DRAFTING_URI = USE_LOCAL_BACKEND
    ? import.meta.env.VITE_LOCAL_BACKEND_URL
    : `${EUREKA_SERVICE_URI}/drafting`;

export const FREE_DRAFTING_URI = USE_LOCAL_BACKEND
    ? `${import.meta.env.VITE_LOCAL_BACKEND_URL}`
    : `${EUREKA_SERVICE_URI}/free/drafting`;


// User Service for payment functionality (拼接路径)
export const USER_SERVICE_URI = `${ACCOUNT_SERVICE_URI}/user-service`;

// export const PASSPORT_URI = transformUrlProxy(SLD.PASSPORT, import.meta.env.VITE_PASSPORT_URI);
// export const CORE_BASIC_SERVICE_URI = import.meta.env.VITE_CORE_BASIC_SERVICE_URI;
// export const STATIC_COMMON_URL = import.meta.env.VITE_STATIC_COMMON_URL;
// export const WORKSPACE_URI = import.meta.env.VITE_WORKSPACE_URI;
// export const WORKSPACE_SERVICE_URI = import.meta.env.VITE_WORKSPACE_SERVICE_URI;

